/**
 * Blog Posts slider section
 * ---------------------------------------------------------------------------
 * Extracted from sections/blog-posts.liquid, where it was inline <script>.
 * Inline scripts are parser-blocking, uncacheable, and re-sent on every page
 * view. This asset is deferred and cached, and initialises every instance on
 * the page instead of binding to a single section id.
 *
 * Initialisation is idempotent: an already-wired element is skipped.
 */
(function () {
  'use strict';

  var SELECTOR = '[data-section-type="blog-slider"]';

  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.blogsliderInit === 'true') return;
    sectionEl.dataset.blogsliderInit = 'true';

    var sectionId = sectionEl.dataset.sectionId;
    const track = sectionEl.querySelector('#BlogSliderTrack-' + sectionId);
    if (!track) return;

    // Enable smooth drag on desktop
    let isDown = false;
    let startX;
    let scrollLeft;

    track.addEventListener('mousedown', (e) => {
      isDown = true;
      track.style.cursor = 'grabbing';
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', () => {
      isDown = false;
      track.style.cursor = '';
    });
    track.addEventListener('mouseup', () => {
      isDown = false;
      track.style.cursor = '';
    });
    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.5;
      track.scrollLeft = scrollLeft - walk;
    });
  }

  function initAll(root) {
    var scope = root || document;
    // On shopify:section:load the event target IS the section element, and
    // querySelectorAll only looks at descendants - so test the root itself too.
    if (scope.matches && scope.matches(SELECTOR)) initSection(scope);
    Array.prototype.forEach.call(scope.querySelectorAll(SELECTOR), initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
